import * as i0 from '@angular/core';
import { InjectionToken, Optional, Inject, Injectable, SkipSelf, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpContext, HttpParams } from '@angular/common/http';

/**
 * Custom HttpParameterCodec
 * Workaround for https://github.com/angular/angular/issues/18261
 */
class CustomHttpParameterCodec {
  encodeKey(k) {
    return encodeURIComponent(k);
  }
  encodeValue(v) {
    return encodeURIComponent(v);
  }
  decodeKey(k) {
    return decodeURIComponent(k);
  }
  decodeValue(v) {
    return decodeURIComponent(v);
  }
}
const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
  'csv': ',',
  'tsv': '   ',
  'ssv': ' ',
  'pipes': '|'
};
class ConnectConfiguration {
  /**
   *  @deprecated Since 5.0. Use credentials instead
   */
  apiKeys;
  username;
  password;
  /**
   *  @deprecated Since 5.0. Use credentials instead
   */
  accessToken;
  basePath;
  withCredentials;
  /**
   * Takes care of encoding query- and form-parameters.
   */
  encoder;
  /**
   * Encoding of various path parameter
   * <a href="https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.0.md#style-values">styles</a>.
   * <p>
   * See {@link README.md} for more details
   * </p>
   */
  encodeParam;
  /**
   * The keys are the names in the securitySchemes section of the OpenAPI
   * document. They should map to the value used for authentication
   * minus any standard prefixes such as 'Basic' or 'Bearer'.
   */
  credentials;
  defaultHeaders;
  constructor(configurationParameters = {}) {
    this.apiKeys = configurationParameters.apiKeys;
    this.username = configurationParameters.username;
    this.password = configurationParameters.password;
    this.accessToken = configurationParameters.accessToken;
    this.basePath = configurationParameters.basePath;
    this.withCredentials = configurationParameters.withCredentials;
    this.encoder = configurationParameters.encoder;
    this.defaultHeaders = configurationParameters.defaultHeaders;
    if (configurationParameters.encodeParam) {
      this.encodeParam = configurationParameters.encodeParam;
    } else {
      this.encodeParam = param => this.defaultEncodeParam(param);
    }
    if (configurationParameters.credentials) {
      this.credentials = configurationParameters.credentials;
    } else {
      this.credentials = {};
    }
    // init default Bearer credential
    if (!this.credentials['Bearer']) {
      this.credentials['Bearer'] = () => {
        return typeof this.accessToken === 'function' ? this.accessToken() : this.accessToken;
      };
    }
  }
  /**
   * Select the correct content-type to use for a request.
   * Uses {@link ConnectConfiguration#isJsonMime} to determine the correct content-type.
   * If no content type is found return the first found type if the contentTypes is not empty
   * @param contentTypes - the array of content types that are available for selection
   * @returns the selected content-type or <code>undefined</code> if no selection could be made.
   */
  selectHeaderContentType(contentTypes) {
    if (contentTypes.length === 0) {
      return undefined;
    }
    const type = contentTypes.find(x => this.isJsonMime(x));
    if (type === undefined) {
      return contentTypes[0];
    }
    return type;
  }
  /**
   * Select the correct accept content-type to use for a request.
   * Uses {@link ConnectConfiguration#isJsonMime} to determine the correct accept content-type.
   * If no content type is found return the first found type if the contentTypes is not empty
   * @param accepts - the array of content types that are available for selection.
   * @returns the selected content-type or <code>undefined</code> if no selection could be made.
   */
  selectHeaderAccept(accepts) {
    if (accepts.length === 0) {
      return undefined;
    }
    const type = accepts.find(x => this.isJsonMime(x));
    if (type === undefined) {
      return accepts[0];
    }
    return type;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
    return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
  }
  lookupCredential(key) {
    const value = this.credentials[key];
    return typeof value === 'function' ? value() : value;
  }
  defaultEncodeParam(param) {
    // This implementation exists as fallback for missing configuration
    // and for backwards compatibility to older typescript-angular generator versions.
    // It only works for the 'simple' parameter style.
    // Date-handling only works for the 'date-time' format.
    // All other styles and Date-formats are probably handled incorrectly.
    //
    // But: if that's all you need (i.e.: the most common use-case): no need for customization!
    const value = param.dataFormat === 'date-time' && param.value instanceof Date ? param.value.toISOString() : param.value;
    return encodeURIComponent(String(value));
  }
}

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ArticleServicesService = /*#__PURE__*/(() => {
  class ArticleServicesService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getArticleServices(articleId, language, observe = 'body', reportProgress = false, options) {
      if (articleId === null || articleId === undefined) {
        throw new Error('Required parameter articleId was null or undefined when calling getArticleServices.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getArticleServices.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/articleservices/${this.configuration.encodeParam({
        name: "articleId",
        value: articleId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ArticleServicesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ArticleServicesService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ArticleServicesService,
      factory: ArticleServicesService.ɵfac,
      providedIn: 'root'
    });
  }
  return ArticleServicesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let CardService = /*#__PURE__*/(() => {
  class CardService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getCardViewConfig(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/card`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function CardService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CardService,
      factory: CardService.ɵfac,
      providedIn: 'root'
    });
  }
  return CardService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ConnectExportService = /*#__PURE__*/(() => {
  class ConnectExportService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    createDeviceTestExport(page, pagemaxitem, language, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling createDeviceTestExport.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling createDeviceTestExport.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling createDeviceTestExport.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/device`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    createDsgvoJob(dsgvoRequest, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/dsgvo`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: dsgvoRequest,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    createMeasExport(page, pagemaxitem, language, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling createMeasExport.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling createMeasExport.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling createMeasExport.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/meas`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getExportState(jobId, orderNumber, token, observe = 'body', reportProgress = false, options) {
      if (jobId === null || jobId === undefined) {
        throw new Error('Required parameter jobId was null or undefined when calling getExportState.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (orderNumber !== undefined && orderNumber !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, orderNumber, 'orderNumber');
      }
      if (token !== undefined && token !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, token, 'token');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/${this.configuration.encodeParam({
        name: "jobId",
        value: jobId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/state`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getExportStream(jobId, orderNumber, token, observe = 'body', reportProgress = false, options) {
      if (jobId === null || jobId === undefined) {
        throw new Error('Required parameter jobId was null or undefined when calling getExportStream.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (orderNumber !== undefined && orderNumber !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, orderNumber, 'orderNumber');
      }
      if (token !== undefined && token !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, token, 'token');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/connectexport/${this.configuration.encodeParam({
        name: "jobId",
        value: jobId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/stream`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOrderCertificateExport(orderId, language, observe = 'body', reportProgress = false, options) {
      if (orderId === null || orderId === undefined) {
        throw new Error('Required parameter orderId was null or undefined when calling getOrderCertificateExport.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getOrderCertificateExport.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/order/${this.configuration.encodeParam({
        name: "orderId",
        value: orderId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOrderCertificateExportByOrderToken(orderNumber, token, language, observe = 'body', reportProgress = false, options) {
      if (orderNumber === null || orderNumber === undefined) {
        throw new Error('Required parameter orderNumber was null or undefined when calling getOrderCertificateExportByOrderToken.');
      }
      if (token === null || token === undefined) {
        throw new Error('Required parameter token was null or undefined when calling getOrderCertificateExportByOrderToken.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getOrderCertificateExportByOrderToken.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/order/${this.configuration.encodeParam({
        name: "orderNumber",
        value: orderNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "token",
        value: token,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getServiceDeviceCertificateExport(serviceProductId, language, observe = 'body', reportProgress = false, options) {
      if (serviceProductId === null || serviceProductId === undefined) {
        throw new Error('Required parameter serviceProductId was null or undefined when calling getServiceDeviceCertificateExport.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getServiceDeviceCertificateExport.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport/serviceproduct/${this.configuration.encodeParam({
        name: "serviceProductId",
        value: serviceProductId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchServiceProducts(serviceProductCertificateExportSearch, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/connectexport`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductCertificateExportSearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ConnectExportService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConnectExportService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConnectExportService,
      factory: ConnectExportService.ɵfac,
      providedIn: 'root'
    });
  }
  return ConnectExportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ContactService = /*#__PURE__*/(() => {
  class ContactService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getContactData(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/contact`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDeliveryAddressContacts(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/contact/deliveryaddress`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateContactData(contact, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/contact`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: contact,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    upgradeToCustomerContact(upgradeToCustomerRequest, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/contact`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: upgradeToCustomerRequest,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ContactService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContactService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ContactService,
      factory: ContactService.ɵfac,
      providedIn: 'root'
    });
  }
  return ContactService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let CreditService = /*#__PURE__*/(() => {
  class CreditService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getCredit(year, observe = 'body', reportProgress = false, options) {
      if (year === null || year === undefined) {
        throw new Error('Required parameter year was null or undefined when calling getCredit.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/credit/${this.configuration.encodeParam({
        name: "year",
        value: year,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCreditInfos(start, end, observe = 'body', reportProgress = false, options) {
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (start !== undefined && start !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, start, 'start');
      }
      if (end !== undefined && end !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, end, 'end');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/credit`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCreditPeriod(creditOverviewFilter, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/credit`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: creditOverviewFilter,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function CreditService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CreditService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CreditService,
      factory: CreditService.ɵfac,
      providedIn: 'root'
    });
  }
  return CreditService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let DeviceGroupsService = /*#__PURE__*/(() => {
  class DeviceGroupsService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    createNewGroup(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    deleteGroup(deviceGroupeId, observe = 'body', reportProgress = false, options) {
      if (deviceGroupeId === null || deviceGroupeId === undefined) {
        throw new Error('Required parameter deviceGroupeId was null or undefined when calling deleteGroup.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups/${this.configuration.encodeParam({
        name: "deviceGroupeId",
        value: deviceGroupeId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDeviceGroup(deviceGroupeId, observe = 'body', reportProgress = false, options) {
      if (deviceGroupeId === null || deviceGroupeId === undefined) {
        throw new Error('Required parameter deviceGroupeId was null or undefined when calling getDeviceGroup.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups/${this.configuration.encodeParam({
        name: "deviceGroupeId",
        value: deviceGroupeId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDeviceGroupsList(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateDeviceGroupDevices(deviceGroup, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: deviceGroup,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateSettings(deviceGroupeId, deviceGroup, observe = 'body', reportProgress = false, options) {
      if (deviceGroupeId === null || deviceGroupeId === undefined) {
        throw new Error('Required parameter deviceGroupeId was null or undefined when calling updateSettings.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/devicegroups/${this.configuration.encodeParam({
        name: "deviceGroupeId",
        value: deviceGroupeId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: deviceGroup,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function DeviceGroupsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeviceGroupsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DeviceGroupsService,
      factory: DeviceGroupsService.ɵfac,
      providedIn: 'root'
    });
  }
  return DeviceGroupsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let DownloadService = /*#__PURE__*/(() => {
  class DownloadService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    downloadFile(downloadInfo, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/download`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: downloadInfo,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDownlaods(count, observe = 'body', reportProgress = false, options) {
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (count !== undefined && count !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, count, 'count');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/download`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function DownloadService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DownloadService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DownloadService,
      factory: DownloadService.ɵfac,
      providedIn: 'root'
    });
  }
  return DownloadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ElasticDeviceTestService = /*#__PURE__*/(() => {
  class ElasticDeviceTestService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    deleteDeviceTest(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling deleteDeviceTest.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticdevicetest/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    initialDeviceTestSearch(page, pagemaxitem, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling initialDeviceTestSearch.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling initialDeviceTestSearch.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticdevicetest/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/init`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    reactivateDeviceTest(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling reactivateDeviceTest.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticdevicetest/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchDeviceTest(page, pagemaxitem, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling searchDeviceTest.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling searchDeviceTest.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticdevicetest/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchDeviceTestByLocation(locationBasedSearchObject, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticdevicetest/location`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: locationBasedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ElasticDeviceTestService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ElasticDeviceTestService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ElasticDeviceTestService,
      factory: ElasticDeviceTestService.ɵfac,
      providedIn: 'root'
    });
  }
  return ElasticDeviceTestService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ElasticMeasService = /*#__PURE__*/(() => {
  class ElasticMeasService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    deleteMeasurement(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling deleteMeasurement.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticmeas/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    initialMeasSearch(page, pagemaxitem, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling initialMeasSearch.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling initialMeasSearch.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticmeas/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/init`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    reactivateMeasurement(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling reactivateMeasurement.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticmeas/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchMeas(page, pagemaxitem, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling searchMeas.');
      }
      if (pagemaxitem === null || pagemaxitem === undefined) {
        throw new Error('Required parameter pagemaxitem was null or undefined when calling searchMeas.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticmeas/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "pagemaxitem",
        value: pagemaxitem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchMeasByLocation(locationBasedSearchObject, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/elasticmeas/location`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: locationBasedSearchObject,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ElasticMeasService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ElasticMeasService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ElasticMeasService,
      factory: ElasticMeasService.ɵfac,
      providedIn: 'root'
    });
  }
  return ElasticMeasService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let FilterService = /*#__PURE__*/(() => {
  class FilterService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    createDeviceTestSearchParameter(availableSearchParameter, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/devicetest`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: availableSearchParameter,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    createMeasSearchParameter(availableSearchParameter, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/meas`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: availableSearchParameter,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    deleteDeviceTestSearchParameter(measType, dataType, field, observe = 'body', reportProgress = false, options) {
      if (measType === null || measType === undefined) {
        throw new Error('Required parameter measType was null or undefined when calling deleteDeviceTestSearchParameter.');
      }
      if (dataType === null || dataType === undefined) {
        throw new Error('Required parameter dataType was null or undefined when calling deleteDeviceTestSearchParameter.');
      }
      if (field === null || field === undefined) {
        throw new Error('Required parameter field was null or undefined when calling deleteDeviceTestSearchParameter.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/devicetest/${this.configuration.encodeParam({
        name: "measType",
        value: measType,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "dataType",
        value: dataType,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "field",
        value: field,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    deleteMeasSearchParameter(measType, dataType, field, observe = 'body', reportProgress = false, options) {
      if (measType === null || measType === undefined) {
        throw new Error('Required parameter measType was null or undefined when calling deleteMeasSearchParameter.');
      }
      if (dataType === null || dataType === undefined) {
        throw new Error('Required parameter dataType was null or undefined when calling deleteMeasSearchParameter.');
      }
      if (field === null || field === undefined) {
        throw new Error('Required parameter field was null or undefined when calling deleteMeasSearchParameter.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/meas/${this.configuration.encodeParam({
        name: "measType",
        value: measType,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "dataType",
        value: dataType,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "field",
        value: field,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDeviceTestSearchParameter(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/devicetest`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getMeasSearchParameter(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/filter/meas`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function FilterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FilterService,
      factory: FilterService.ɵfac,
      providedIn: 'root'
    });
  }
  return FilterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let LiveMeasService = /*#__PURE__*/(() => {
  class LiveMeasService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    checkLiveUpdate(checkLiveUpdate, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/livemeas`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: checkLiveUpdate,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getLiveMeasurements(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/livemeas`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getLiveMeasurementsDetail(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getLiveMeasurementsDetail.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/livemeas/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/detail`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function LiveMeasService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LiveMeasService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LiveMeasService,
      factory: LiveMeasService.ɵfac,
      providedIn: 'root'
    });
  }
  return LiveMeasService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let LoggingService = /*#__PURE__*/(() => {
  class LoggingService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    nothing(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/logging`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function LoggingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoggingService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LoggingService,
      factory: LoggingService.ɵfac,
      providedIn: 'root'
    });
  }
  return LoggingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let LogoService = /*#__PURE__*/(() => {
  class LogoService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    deleteCostumerLogo(logoId, observe = 'body', reportProgress = false, options) {
      if (logoId === null || logoId === undefined) {
        throw new Error('Required parameter logoId was null or undefined when calling deleteCostumerLogo.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/logo/${this.configuration.encodeParam({
        name: "logoId",
        value: logoId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getLogoById(logoId, observe = 'body', reportProgress = false, options) {
      if (logoId === null || logoId === undefined) {
        throw new Error('Required parameter logoId was null or undefined when calling getLogoById.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/logo/${this.configuration.encodeParam({
        name: "logoId",
        value: logoId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getLogos(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/logo`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    saveCustomerLogo(customerLogo, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['text/plain', 'application/json', 'text/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/logo/new`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: customerLogo,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function LogoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogoService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LogoService,
      factory: LogoService.ɵfac,
      providedIn: 'root'
    });
  }
  return LogoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let MdeService = /*#__PURE__*/(() => {
  class MdeService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getMdeData(device, serial, observe = 'body', reportProgress = false, options) {
      if (device === null || device === undefined) {
        throw new Error('Required parameter device was null or undefined when calling getMdeData.');
      }
      if (serial === null || serial === undefined) {
        throw new Error('Required parameter serial was null or undefined when calling getMdeData.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/mde/${this.configuration.encodeParam({
        name: "device",
        value: device,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "serial",
        value: serial,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getMdeMenus(device, serial, observe = 'body', reportProgress = false, options) {
      if (device === null || device === undefined) {
        throw new Error('Required parameter device was null or undefined when calling getMdeMenus.');
      }
      if (serial === null || serial === undefined) {
        throw new Error('Required parameter serial was null or undefined when calling getMdeMenus.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/mde/${this.configuration.encodeParam({
        name: "device",
        value: device,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "serial",
        value: serial,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/availablemenu`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getMenuMde(device, serial, menuid, observe = 'body', reportProgress = false, options) {
      if (device === null || device === undefined) {
        throw new Error('Required parameter device was null or undefined when calling getMenuMde.');
      }
      if (serial === null || serial === undefined) {
        throw new Error('Required parameter serial was null or undefined when calling getMenuMde.');
      }
      if (menuid === null || menuid === undefined) {
        throw new Error('Required parameter menuid was null or undefined when calling getMenuMde.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/mde/${this.configuration.encodeParam({
        name: "device",
        value: device,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "serial",
        value: serial,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/menu/${this.configuration.encodeParam({
        name: "menuid",
        value: menuid,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    postMdeListForDevice(device, serial, mDEData, observe = 'body', reportProgress = false, options) {
      if (device === null || device === undefined) {
        throw new Error('Required parameter device was null or undefined when calling postMdeListForDevice.');
      }
      if (serial === null || serial === undefined) {
        throw new Error('Required parameter serial was null or undefined when calling postMdeListForDevice.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/mde/${this.configuration.encodeParam({
        name: "device",
        value: device,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "serial",
        value: serial,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: mDEData,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    postMdeListForDeviceGroup(device, groupid, mDEData, observe = 'body', reportProgress = false, options) {
      if (device === null || device === undefined) {
        throw new Error('Required parameter device was null or undefined when calling postMdeListForDeviceGroup.');
      }
      if (groupid === null || groupid === undefined) {
        throw new Error('Required parameter groupid was null or undefined when calling postMdeListForDeviceGroup.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/mde/${this.configuration.encodeParam({
        name: "device",
        value: device,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/group/${this.configuration.encodeParam({
        name: "groupid",
        value: groupid,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/template`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: mDEData,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function MdeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MdeService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MdeService,
      factory: MdeService.ɵfac,
      providedIn: 'root'
    });
  }
  return MdeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let MeasDataService = /*#__PURE__*/(() => {
  class MeasDataService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getChannelCharts(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getChannelCharts.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/measdata/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/channels`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCompleteMsgPackData(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getCompleteMsgPackData.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/measdata/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/measmsgpackdata`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getDeviceTestDetails(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getDeviceTestDetails.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/measdata/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/detail/device`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getMeasDetails(measId, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getMeasDetails.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/measdata/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/detail/meas`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateMde(measId, measDetail, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling updateMde.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/measdata/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: measDetail,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function MeasDataService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MeasDataService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MeasDataService,
      factory: MeasDataService.ɵfac,
      providedIn: 'root'
    });
  }
  return MeasDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let MenuService = /*#__PURE__*/(() => {
  class MenuService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getMenus(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/menu`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function MenuService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MenuService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MenuService,
      factory: MenuService.ɵfac,
      providedIn: 'root'
    });
  }
  return MenuService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let MultiReportService = /*#__PURE__*/(() => {
  class MultiReportService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getMultiFileReport(page, maxItem, language, detailedSearchObject, observe = 'body', reportProgress = false, options) {
      if (page === null || page === undefined) {
        throw new Error('Required parameter page was null or undefined when calling getMultiFileReport.');
      }
      if (maxItem === null || maxItem === undefined) {
        throw new Error('Required parameter maxItem was null or undefined when calling getMultiFileReport.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getMultiFileReport.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octect-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let localVarPath = `/multireport/${this.configuration.encodeParam({
        name: "page",
        value: page,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "maxItem",
        value: maxItem,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: detailedSearchObject,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function MultiReportService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MultiReportService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MultiReportService,
      factory: MultiReportService.ɵfac,
      providedIn: 'root'
    });
  }
  return MultiReportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let OperatingManualService = /*#__PURE__*/(() => {
  class OperatingManualService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getOperatingManual(opertaingManualId, observe = 'body', reportProgress = false, options) {
      if (opertaingManualId === null || opertaingManualId === undefined) {
        throw new Error('Required parameter opertaingManualId was null or undefined when calling getOperatingManual.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/operatingmanual/${this.configuration.encodeParam({
        name: "opertaingManualId",
        value: opertaingManualId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getOperatingManualByOrderToken(opertaingManualId, orderNumber, token, observe = 'body', reportProgress = false, options) {
      if (opertaingManualId === null || opertaingManualId === undefined) {
        throw new Error('Required parameter opertaingManualId was null or undefined when calling getOperatingManualByOrderToken.');
      }
      if (orderNumber === null || orderNumber === undefined) {
        throw new Error('Required parameter orderNumber was null or undefined when calling getOperatingManualByOrderToken.');
      }
      if (token === null || token === undefined) {
        throw new Error('Required parameter token was null or undefined when calling getOperatingManualByOrderToken.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/operatingmanual/${this.configuration.encodeParam({
        name: "opertaingManualId",
        value: opertaingManualId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/order/${this.configuration.encodeParam({
        name: "orderNumber",
        value: orderNumber,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "token",
        value: token,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function OperatingManualService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OperatingManualService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OperatingManualService,
      factory: OperatingManualService.ɵfac,
      providedIn: 'root'
    });
  }
  return OperatingManualService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ProductRegistrationService = /*#__PURE__*/(() => {
  class ProductRegistrationService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getServiceProductRegistrationInfo(serial, observe = 'body', reportProgress = false, options) {
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (serial !== undefined && serial !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, serial, 'serial');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/productregistration`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getServiceProductRegistrationInfoState(serial, observe = 'body', reportProgress = false, options) {
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (serial !== undefined && serial !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, serial, 'serial');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/productregistration/state`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    registratePrivateUserServiceProduct(updateOnly, serviceProductRegistration, observe = 'body', reportProgress = false, options) {
      if (updateOnly === null || updateOnly === undefined) {
        throw new Error('Required parameter updateOnly was null or undefined when calling registratePrivateUserServiceProduct.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/productregistration/${this.configuration.encodeParam({
        name: "updateOnly",
        value: updateOnly,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "boolean",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductRegistration,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ProductRegistrationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductRegistrationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductRegistrationService,
      factory: ProductRegistrationService.ɵfac,
      providedIn: 'root'
    });
  }
  return ProductRegistrationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let RegionService = /*#__PURE__*/(() => {
  class RegionService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getCountriesAndLanguages(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/region`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function RegionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RegionService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RegionService,
      factory: RegionService.ɵfac,
      providedIn: 'root'
    });
  }
  return RegionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ReportService = /*#__PURE__*/(() => {
  class ReportService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getCsvFile(measId, language, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getCsvFile.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getCsvFile.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/report/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/csv`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getLiveMeasPdf(measId, language, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getLiveMeasPdf.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getLiveMeasPdf.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/report/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/pdf/live`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getPdfFile(measId, language, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getPdfFile.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getPdfFile.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/report/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/pdf`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getXlsxFile(measId, language, observe = 'body', reportProgress = false, options) {
      if (measId === null || measId === undefined) {
        throw new Error('Required parameter measId was null or undefined when calling getXlsxFile.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getXlsxFile.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/report/${this.configuration.encodeParam({
        name: "measId",
        value: measId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/xlsx`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    singleReportPdf(language, fullElasticIndex, observe = 'body', reportProgress = false, options) {
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling singleReportPdf.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let localVarPath = `/report/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/pdf`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: fullElasticIndex,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ReportService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReportService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReportService,
      factory: ReportService.ɵfac,
      providedIn: 'root'
    });
  }
  return ReportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ServiceOfferService = /*#__PURE__*/(() => {
  class ServiceOfferService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    deleteServiceOffer(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceoffer`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    deleteServiceOfferPos(offerPos, observe = 'body', reportProgress = false, options) {
      if (offerPos === null || offerPos === undefined) {
        throw new Error('Required parameter offerPos was null or undefined when calling deleteServiceOfferPos.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceoffer/${this.configuration.encodeParam({
        name: "offerPos",
        value: offerPos,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('delete', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    finishServiceOffer(serviceOffer, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceoffer`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceOffer,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getServiceOffer(language, observe = 'body', reportProgress = false, options) {
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getServiceOffer.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceoffer/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    putToActiveServiceOffer(language, serviceOfferArticleServicePosition, observe = 'body', reportProgress = false, options) {
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling putToActiveServiceOffer.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceoffer/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceOfferArticleServicePosition,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ServiceOfferService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ServiceOfferService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ServiceOfferService,
      factory: ServiceOfferService.ɵfac,
      providedIn: 'root'
    });
  }
  return ServiceOfferService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let ServiceProductService = /*#__PURE__*/(() => {
  class ServiceProductService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    changeServiceProductAdditionalInfos(serviceProduct, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/changes`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProduct,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCertificate(serviceProductId, cert, language, observe = 'body', reportProgress = false, options) {
      if (serviceProductId === null || serviceProductId === undefined) {
        throw new Error('Required parameter serviceProductId was null or undefined when calling getCertificate.');
      }
      if (cert === null || cert === undefined) {
        throw new Error('Required parameter cert was null or undefined when calling getCertificate.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getCertificate.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/serviceproduct/${this.configuration.encodeParam({
        name: "serviceProductId",
        value: serviceProductId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/certificate/${this.configuration.encodeParam({
        name: "cert",
        value: cert,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getCertificateWithOrderToken(serviceProductId, cert, language, orderNumber, token, observe = 'body', reportProgress = false, options) {
      if (serviceProductId === null || serviceProductId === undefined) {
        throw new Error('Required parameter serviceProductId was null or undefined when calling getCertificateWithOrderToken.');
      }
      if (cert === null || cert === undefined) {
        throw new Error('Required parameter cert was null or undefined when calling getCertificateWithOrderToken.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getCertificateWithOrderToken.');
      }
      let localVarQueryParameters = new HttpParams({
        encoder: this.encoder
      });
      if (orderNumber !== undefined && orderNumber !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, orderNumber, 'orderNumber');
      }
      if (token !== undefined && token !== null) {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, token, 'token');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/pdf'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let localVarPath = `/serviceproduct/${this.configuration.encodeParam({
        name: "serviceProductId",
        value: serviceProductId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/certificate/${this.configuration.encodeParam({
        name: "cert",
        value: cert,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "number",
        dataFormat: "int32"
      })}/ordertoken`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: "blob",
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getServiceProductDetails(serviceProductId, language, observe = 'body', reportProgress = false, options) {
      if (serviceProductId === null || serviceProductId === undefined) {
        throw new Error('Required parameter serviceProductId was null or undefined when calling getServiceProductDetails.');
      }
      if (language === null || language === undefined) {
        throw new Error('Required parameter language was null or undefined when calling getServiceProductDetails.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/${this.configuration.encodeParam({
        name: "serviceProductId",
        value: serviceProductId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/${this.configuration.encodeParam({
        name: "language",
        value: language,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    getServiceProductsReminder(reminderToken, serviceProductSearch, observe = 'body', reportProgress = false, options) {
      if (reminderToken === null || reminderToken === undefined) {
        throw new Error('Required parameter reminderToken was null or undefined when calling getServiceProductsReminder.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/servicereminder/${this.configuration.encodeParam({
        name: "reminderToken",
        value: reminderToken,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductSearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    postRequestServiceProductListCsv(serviceProductSearch, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/octet-stream'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/csv`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductSearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    registratePrivateUserServiceProduct(serviceProductRegistration, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/serviceproductregistration`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductRegistration,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    searchServiceProducts(serviceProductSearch, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct`;
      return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: serviceProductSearch,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    serviceReminderAuthCheck(contactId, reminderToken, observe = 'body', reportProgress = false, options) {
      if (contactId === null || contactId === undefined) {
        throw new Error('Required parameter contactId was null or undefined when calling serviceReminderAuthCheck.');
      }
      if (reminderToken === null || reminderToken === undefined) {
        throw new Error('Required parameter reminderToken was null or undefined when calling serviceReminderAuthCheck.');
      }
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/serviceproduct/${this.configuration.encodeParam({
        name: "contactId",
        value: contactId,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}/servicereminder/${this.configuration.encodeParam({
        name: "reminderToken",
        value: reminderToken,
        in: "path",
        style: "simple",
        explode: false,
        dataType: "string",
        dataFormat: undefined
      })}`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function ServiceProductService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ServiceProductService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ServiceProductService,
      factory: ServiceProductService.ɵfac,
      providedIn: 'root'
    });
  }
  return ServiceProductService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let UsersService = /*#__PURE__*/(() => {
  class UsersService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getUser(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/users`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    setDiclaimerOk(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = [];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/users/disclaimer`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    updateUserRoles(coreUser, observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarCredential;
      // authentication (Bearer) required
      localVarCredential = this.configuration.lookupCredential('Bearer');
      if (localVarCredential) {
        localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
      }
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      // to determine the Content-Type header
      const consumes = ['application/json'];
      const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/users`;
      return this.httpClient.request('put', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        body: coreUser,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function UsersService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UsersService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UsersService,
      factory: UsersService.ɵfac,
      providedIn: 'root'
    });
  }
  return UsersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
let VersionService = /*#__PURE__*/(() => {
  class VersionService {
    httpClient;
    basePath = 'https://api.esders.de/connect/1.0';
    defaultHeaders = new HttpHeaders();
    configuration = new ConnectConfiguration();
    encoder;
    constructor(httpClient, basePath, configuration) {
      this.httpClient = httpClient;
      if (configuration) {
        this.configuration = configuration;
        if (configuration.defaultHeaders) {
          for (const [key, value] of Object.entries(configuration.defaultHeaders)) {
            this.defaultHeaders = this.defaultHeaders.set(key, value);
          }
        }
      }
      if (typeof this.configuration.basePath !== 'string') {
        if (Array.isArray(basePath) && basePath.length > 0) {
          basePath = basePath[0];
        }
        if (typeof basePath !== 'string') {
          basePath = this.basePath;
        }
        this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }
    // @ts-ignore
    addToHttpParams(httpParams, value, key) {
      if (typeof value === "object" && value instanceof Date === false) {
        httpParams = this.addToHttpParamsRecursive(httpParams, value);
      } else {
        httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
      }
      return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
      if (value == null) {
        return httpParams;
      }
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          value.forEach(elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
        } else if (value instanceof Date) {
          if (key != null) {
            httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
          } else {
            throw Error("key may not be null if value is Date");
          }
        } else {
          Object.keys(value).forEach(k => httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k));
        }
      } else if (key != null) {
        httpParams = httpParams.append(key, value);
      } else {
        throw Error("key may not be null if value is not object or array");
      }
      return httpParams;
    }
    getVersion(observe = 'body', reportProgress = false, options) {
      let localVarHeaders = this.defaultHeaders;
      let localVarHttpHeaderAcceptSelected = options && options.httpHeaderAccept;
      if (localVarHttpHeaderAcceptSelected === undefined) {
        // to determine the Accept header
        const httpHeaderAccepts = ['application/json'];
        localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      }
      if (localVarHttpHeaderAcceptSelected !== undefined) {
        localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
      }
      let localVarHttpContext = options && options.context;
      if (localVarHttpContext === undefined) {
        localVarHttpContext = new HttpContext();
      }
      let responseType_ = 'json';
      if (localVarHttpHeaderAcceptSelected) {
        if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
          responseType_ = 'text';
        } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
          responseType_ = 'json';
        } else {
          responseType_ = 'blob';
        }
      }
      let localVarPath = `/version`;
      return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`, {
        context: localVarHttpContext,
        responseType: responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      });
    }
    static ɵfac = function VersionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VersionService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(BASE_PATH, 8), i0.ɵɵinject(ConnectConfiguration, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: VersionService,
      factory: VersionService.ɵfac,
      providedIn: 'root'
    });
  }
  return VersionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const APIS = [ArticleServicesService, CardService, ConnectExportService, ContactService, CreditService, DeviceGroupsService, DownloadService, ElasticDeviceTestService, ElasticMeasService, FilterService, LiveMeasService, LoggingService, LogoService, MdeService, MeasDataService, MenuService, MultiReportService, OperatingManualService, ProductRegistrationService, RegionService, ReportService, ServiceOfferService, ServiceProductService, UsersService, VersionService];

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Certificate = /*#__PURE__*/function (Certificate) {
  Certificate.CertificateTypEnum = {
    TestCertificate: 'TestCertificate',
    IncommingCertificate: 'IncommingCertificate',
    DguvV3: 'DGUV_V3',
    DAkkS: 'DAkkS',
    MeasUncert: 'MeasUncert'
  };
  Certificate.CertificateFormatEnum = {
    CertificateAgp: 'CertificateAGP',
    CertificateDefault: 'CertificateDefault',
    CertificateMu: 'CertificateMU'
  };
  return Certificate;
}(Certificate || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var Config = /*#__PURE__*/function (Config) {
  Config.TagEnum = {
    SimpleTranslate: 'SimpleTranslate',
    Value: 'Value',
    TranslateValue: 'TranslateValue',
    Text: 'Text',
    DateTextWithoutPoints: 'DateTextWithoutPoints',
    Date: 'Date',
    Mde: 'MDE'
  };
  return Config;
}(Config || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var ContactCrm = /*#__PURE__*/function (ContactCrm) {
  ContactCrm.EsdersRelationEnum = {
    Customer: 'Customer',
    Dealer: 'Dealer',
    ProspectiveCustomer: 'ProspectiveCustomer'
  };
  return ContactCrm;
}(ContactCrm || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var CreditInfoPerPeriod = /*#__PURE__*/function (CreditInfoPerPeriod) {
  CreditInfoPerPeriod.PeriodTypeEnum = {
    Daily: 'Daily',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
  };
  return CreditInfoPerPeriod;
}(CreditInfoPerPeriod || {});
var CustomerCrm = /*#__PURE__*/function (CustomerCrm) {
  CustomerCrm.EsdersRelationEnum = {
    Customer: 'Customer',
    Dealer: 'Dealer',
    ProspectiveCustomer: 'ProspectiveCustomer'
  };
  return CustomerCrm;
}(CustomerCrm || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var DownloadInfo = /*#__PURE__*/function (DownloadInfo) {
  DownloadInfo.StateEnum = {
    Waiting: 'Waiting',
    Working: 'Working',
    Ready: 'Ready',
    Error: 'Error'
  };
  DownloadInfo.TypeEnum = {
    Meas: 'Meas',
    Cert: 'Cert',
    MultiMeas: 'MultiMeas',
    TimerangeCert: 'TimerangeCert',
    DeviceTestMeas: 'DeviceTestMeas',
    Dsvgo: 'Dsvgo'
  };
  return DownloadInfo;
}(DownloadInfo || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Job = /*#__PURE__*/function (Job) {
  Job.JobTypeEnum = {
    Meas: 'Meas',
    Cert: 'Cert',
    MultiMeas: 'MultiMeas',
    TimerangeCert: 'TimerangeCert',
    DeviceTestMeas: 'DeviceTestMeas',
    Dsvgo: 'Dsvgo'
  };
  Job.StateEnum = {
    Waiting: 'Waiting',
    Working: 'Working',
    Ready: 'Ready',
    Error: 'Error'
  };
  return Job;
}(Job || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Note = /*#__PURE__*/function (Note) {
  Note.CustomerSatisfactionEnum = {
    VeryBad: 'VeryBad',
    Bad: 'Bad',
    Neutral: 'Neutral',
    Good: 'Good',
    VeryGood: 'VeryGood'
  };
  return Note;
}(Note || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Opportunity = /*#__PURE__*/function (Opportunity) {
  Opportunity.ActivePhaseEnum = {
    Phase1: 'Phase1',
    Phase2: 'Phase2',
    Phase3: 'Phase3',
    Phase4: 'Phase4',
    Phase5: 'Phase5',
    Phase6: 'Phase6',
    Phase7: 'Phase7',
    Phase8: 'Phase8'
  };
  return Opportunity;
}(Opportunity || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var Process = /*#__PURE__*/function (Process) {
  Process.StateEnum = {
    Waiting: 'Waiting',
    Working: 'Working',
    Ready: 'Ready',
    Error: 'Error'
  };
  Process.TypeEnum = {
    Meas: 'Meas',
    Cert: 'Cert',
    MultiMeas: 'MultiMeas',
    TimerangeCert: 'TimerangeCert',
    DeviceTestMeas: 'DeviceTestMeas',
    Dsvgo: 'Dsvgo'
  };
  return Process;
}(Process || {});
var Product = /*#__PURE__*/function (Product) {
  Product.ProductTypeEnum = {
    Article: 'Article',
    Extraposition: 'Extraposition'
  };
  Product.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return Product;
}(Product || {});
var ProductFeatureListProperties = /*#__PURE__*/function (ProductFeatureListProperties) {
  ProductFeatureListProperties.TypeEnum = {
    Int: 'Int',
    Float: 'Float',
    Bool: 'Bool',
    String: 'String'
  };
  return ProductFeatureListProperties;
}(ProductFeatureListProperties || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var ProductRegistrationInfo = /*#__PURE__*/function (ProductRegistrationInfo) {
  ProductRegistrationInfo.RegistrationStateEnum = {
    RightUser: 'RightUser',
    DifferentUser: 'DifferentUser',
    NotRegistered: 'NotRegistered'
  };
  return ProductRegistrationInfo;
}(ProductRegistrationInfo || {});
var Receipt = /*#__PURE__*/function (Receipt) {
  Receipt.ReceiptTypeEnum = {
    Complaint: 'Complaint',
    Delivery: 'Delivery',
    Invoice: 'Invoice',
    SalesOffer: 'SalesOffer',
    SalesOrder: 'SalesOrder',
    ServiceOffer: 'ServiceOffer',
    ServiceOrder: 'ServiceOrder',
    PurchaseOrder: 'PurchaseOrder',
    PurchaseRequest: 'PurchaseRequest',
    PurchaseInvoice: 'PurchaseInvoice',
    PurchasePackingSlip: 'PurchasePackingSlip',
    PurchaseBlanketOrder: 'PurchaseBlanketOrder'
  };
  return Receipt;
}(Receipt || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var ServiceProduct = /*#__PURE__*/function (ServiceProduct) {
  ServiceProduct.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return ServiceProduct;
}(ServiceProduct || {});
var ServiceProductArticle = /*#__PURE__*/function (ServiceProductArticle) {
  ServiceProductArticle.CertificateTypeEnum = {
    Default: 'Default',
    NoCertificateNoServicedate: 'NoCertificateNoServicedate',
    CertificateAndServicedateFromAbascal: 'CertificateAndServicedateFromAbascal',
    CertificateAndServicedateWithoutInput: 'CertificateAndServicedateWithoutInput',
    Unknown: 'Unknown'
  };
  return ServiceProductArticle;
}(ServiceProductArticle || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var UpgradeToCustomerRequest = /*#__PURE__*/function (UpgradeToCustomerRequest) {
  UpgradeToCustomerRequest.RequestSourceEnum = {
    Connect: 'Connect',
    Abas: 'Abas',
    MultipleMail: 'MultipleMail'
  };
  return UpgradeToCustomerRequest;
}(UpgradeToCustomerRequest || {});
/**
 * ESD NGPOnlineAPIGateway RESTService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 357.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
let ConnectApiModule = /*#__PURE__*/(() => {
  class ConnectApiModule {
    static forRoot(configurationFactory) {
      return {
        ngModule: ConnectApiModule,
        providers: [{
          provide: ConnectConfiguration,
          useFactory: configurationFactory
        }]
      };
    }
    constructor(parentModule, http) {
      if (parentModule) {
        throw new Error('ConnectApiModule is already loaded. Import in your base AppModule only.');
      }
      if (!http) {
        throw new Error('You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575');
      }
    }
    static ɵfac = function ConnectApiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConnectApiModule)(i0.ɵɵinject(ConnectApiModule, 12), i0.ɵɵinject(i1.HttpClient, 8));
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ConnectApiModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return ConnectApiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, ArticleServicesService, BASE_PATH, COLLECTION_FORMATS, CardService, Certificate, Config, ConnectApiModule, ConnectConfiguration, ConnectExportService, ContactCrm, ContactService, CreditInfoPerPeriod, CreditService, CustomerCrm, DeviceGroupsService, DownloadInfo, DownloadService, ElasticDeviceTestService, ElasticMeasService, FilterService, Job, LiveMeasService, LoggingService, LogoService, MdeService, MeasDataService, MenuService, MultiReportService, Note, OperatingManualService, Opportunity, Process, Product, ProductFeatureListProperties, ProductRegistrationInfo, ProductRegistrationService, Receipt, RegionService, ReportService, ServiceOfferService, ServiceProduct, ServiceProductArticle, ServiceProductService, UpgradeToCustomerRequest, UsersService, VersionService };
